import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "screener-modal-heading",
  class: "pvd-modal__heading"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_pvd_modal = _resolveComponent("pvd-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_pvd_modal, {
      ref: "screener-modal",
      id: "screener-modal",
      "pvd-modal-width": "800",
      "pvd-z-index": "9999999"
    }, {
      default: _withCtx(() => [
        _createElementVNode("h3", _hoisted_1, _toDisplayString(_ctx.clientConstants.SCREENER_SELECT_LINK), 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.clientConstants.SCREENER_SELECT.INFO_1), 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.clientConstants.SCREENER_SELECT.INFO_2), 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.clientConstants.SCREENER_SELECT.INFO_3), 1)
      ]),
      _: 1
    }, 512)
  ]))
}